export default{
    clientes: [],
    clienteSelec: null,
    totalClientes: 0,

   
}